import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { notification, Pagination, Spin, Tooltip } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useParams } from "react-router-dom";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import { addShowValidation } from "../../../utils/validations";
import EditShow from "./EditShow";

const AddShow = (props) => {
  const actions = {
    edit_show: true,
    delete_show: true,
  };
  const {
    loder,
    settingsRecordsPerPage,
    userId,
    setNotify,
    notify,
    editShow,
    deleteShows,
    setLoder,
    addShow,
    getShows,
  } = props;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [showDetail, setShowDetail] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [shows, setShows] = useState([]);
  const [delLoder, setDelLoder] = useState(false);
  const [showId, setShowId] = useState("");
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(20);
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [initialState, setInitialState] = useState({
    showName: "",
    showcast: "",
  });
  const { id } = useParams();

  const handleSubmit = async ({ showcast, showName }) => {
    setLoder(true);
    const { value } = await addShow({
      entityId: id,
      showName,
      showCast: showcast !== "" ? showcast.toString().split(",") : [],
    });
    if (value.success) {
      if (value?.message === "Show already exists...") {
        setNotify(true);
      } else {
        notification["success"]({ message: value.message });
        setNotify(false);
        setIsOpen(false);
      }
    } else {
      notification["error"]({ message: value.message });
    }
    setLoder(false);
    getShow();
  };

  const getShow = async () => {
    setLoder(true);
    const { value } = await getShows({ entityId: id });
    if (value?.status) {
      setShows(value?.data);
    } else {
      notification["error"]({ message: value.message });
    }
    setLoder(false);
  };

  useEffect(() => {
    if (userId) {
      getShow();
    }
  }, []);

  const handlChange = (setFieldValue, e) => {
    if (e?.target?.name) {
      setFieldValue(e.target.name, e.target.value);
    }
    setNotify(false);
  };

  const deleteChannelModel = async () => {
    setDelLoder(true);
    const { value } = await deleteShows({ showId, entityId: id });
    if (value?.status) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    setDelLoder(false);
    getShow();
    delclose();
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setNotify(false);
  };

  const delOpen = (data) => {
    setShowId(data?.showId);
    setDeleteModalOpen(true);
  };

  const EditOpen = () => {
    setEditOpen(true);
  };

  const handlePageChange = (current) => {
    setActivePage(current);
    setEnd(current * settingsRecordsPerPage);
    setStart(current * settingsRecordsPerPage - settingsRecordsPerPage);
  };

  const handleClick = (data) => {
    setShowDetail(data);
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const handleChannelTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "edit_show":
            menuItems.push({
              label: (
                <AccessControl code="edit_show" page="organization-profile">
                  <a
                    onClick={() => {
                      EditOpen();
                    }}
                  >
                    <EditOutlined />
                    <span>Edit</span>
                  </a>
                </AccessControl>
              ),
              key: "1",
            });
            break;
          case "delete_show":
            menuItems.push({
              label: (
                <AccessControl code="delete_show" page="organization-profile">
                  <a
                    onClick={() => {
                      delOpen(showDetail);
                    }}
                  >
                    <DeleteIcon />
                    <span>Delete</span>
                  </a>
                </AccessControl>
              ),
              key: "2",
            });
            break;
        }
      }
    }
  };

  return (
    <>
      <DeleteModal
        setDeleteModalOpen={setDeleteModalOpen}
        modalIsOpen={delmodalOpen}
        loder={delLoder}
        deleteComanModel={deleteChannelModel}
        header="Delete"
        content="Are you sure you want to delete?"
      />
      <EditShow
        setEditOpen={setEditOpen}
        modalIsOpen={modalIsOpen}
        editOpen={editOpen}
        loder={loder}
        userId={userId}
        notify={notify}
        setNotify={setNotify}
        editShow={editShow}
        showDetail={showDetail}
        setLoder={setLoder}
        getShow={getShow}
        initialState={initialState}
      />

      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Shows</h4>
          </div>
          <div className="right-btn-block">
            <div class="button-container">
              <AccessControl code="add_show" page="organization-profile">
                <button class="btn btn-primary" onClick={openModal}>
                  Add Show
                </button>
              </AccessControl>
            </div>
          </div>
        </div>
        <br />
        <div className="configuration-items-row mt-3 row">
          <div className="row mb-4 justify-content-start">
            <div className="col-md-6">
              <h5 className="title-small mb-0">Added Shows</h5>
            </div>
          </div>
          <br />
          <div className="border-block mt-3">
            <div className="row">
              <div className="col-md-12">
                <div className="table-resposive table-container user-management-table">
                  <table className="table">
                    <>
                      <thead>
                        <tr>
                          <th>Show Name</th>
                          <th>Show Casts</th>
                          <th style={{ textAlign: "center" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {shows?.length ? (
                          shows?.slice(start, end)?.map((show) => {
                            return (
                              <tr key={show?._id}>
                                <td className="word-break-two title_Pascal">
                                  {" "}
                                  <Tooltip title={show?.showName}>{show?.showName}</Tooltip>
                                </td>
                                <td>
                                  <Tooltip title={show?.showCast.length ? show.showCast.join(", ") : ""}>
                                    {show?.showCast.length ? show.showCast.join(", ") : ""}
                                  </Tooltip>
                                </td>
                                <td>
                                  <div className="table-action-block text-center">
                                    <Dropdown
                                      onClick={() => {
                                        handleClick(show);
                                      }}
                                      className=""
                                      overlay={
                                        <AccessControl
                                          code="menuItem"
                                          page="organization-profile"
                                          handleTableAction={handleChannelTableAction}
                                        />
                                      }
                                      trigger={["click"]}
                                      overlayClassName={"tableActionBlock"}
                                      placement={"bottomRight"}
                                    >
                                      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                        <TheeDotsIcon />
                                      </a>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>
                            <tr>
                              <td colSpan="7">
                                <div className="text-center  pt-5 pb-5">
                                  <h3>No Shows found</h3>
                                </div>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </>
                    <tfoot></tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={shows?.length}
          className="text-center mt-3"
        />
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered filter-modal"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Add Show</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialState} validationSchema={addShowValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">
                        {" "}
                        Show Name <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="form-control"
                          name="showName"
                          type="text"
                          placeholder="Enter show Name"
                          value={values.showName}
                          onChange={(e) => handlChange(setFieldValue, e)}
                        />
                        {notify && <div className="invalid-feedback">show already exists!</div>}
                        {touched.showName && errors.showName && (
                          <div className="invalid-feedback">{errors.showName}</div>
                        )}
                      </div>
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">Show cast</label>
                      <Field className="form-control" name="showcast" type="text" placeholder="Enter cast" />
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder && (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default AddShow;
